export default __webpack_public_path__ + "static/media/LocationPin.37ee02f0.webm";